import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

/** @format */

/**
 * External dependencies
 */
import { select as d3Select } from 'd3-selection';
import moment from 'moment';

var ChartTooltip =
/*#__PURE__*/
function () {
  function ChartTooltip() {
    _classCallCheck(this, ChartTooltip);

    this.ref = null;
    this.chart = null;
    this.position = '';
    this.title = '';
    this.labelFormat = '';
    this.valueFormat = '';
    this.visibleKeys = '';
    this.getColor = null;
    this.margin = 24;
  }

  _createClass(ChartTooltip, [{
    key: "calculateXPosition",
    value: function calculateXPosition(elementCoords, chartCoords, elementWidthRatio) {
      var tooltipSize = this.ref.getBoundingClientRect();
      var d3BaseCoords = this.ref.parentNode.querySelector('.d3-base').getBoundingClientRect();
      var leftMargin = Math.max(d3BaseCoords.left, chartCoords.left);

      if (this.position === 'below') {
        return Math.max(this.margin, Math.min(elementCoords.left + elementCoords.width * 0.5 - tooltipSize.width / 2 - leftMargin, d3BaseCoords.width - tooltipSize.width - this.margin));
      }

      var xPosition = elementCoords.left + elementCoords.width * elementWidthRatio + this.margin - leftMargin;

      if (xPosition + tooltipSize.width + this.margin > d3BaseCoords.width) {
        return Math.max(this.margin, elementCoords.left + elementCoords.width * (1 - elementWidthRatio) - tooltipSize.width - this.margin - leftMargin);
      }

      return xPosition;
    }
  }, {
    key: "calculateYPosition",
    value: function calculateYPosition(elementCoords, chartCoords) {
      if (this.position === 'below') {
        return chartCoords.height;
      }

      var tooltipSize = this.ref.getBoundingClientRect();
      var yPosition = elementCoords.top + this.margin - chartCoords.top;

      if (yPosition + tooltipSize.height + this.margin > chartCoords.height) {
        return Math.max(0, elementCoords.top - tooltipSize.height - this.margin - chartCoords.top);
      }

      return yPosition;
    }
  }, {
    key: "calculatePosition",
    value: function calculatePosition(element) {
      var elementWidthRatio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var elementCoords = element.getBoundingClientRect();
      var chartCoords = this.chart.getBoundingClientRect();

      if (this.position === 'below') {
        elementWidthRatio = 0;
      }

      return {
        x: this.calculateXPosition(elementCoords, chartCoords, elementWidthRatio),
        y: this.calculateYPosition(elementCoords, chartCoords)
      };
    }
  }, {
    key: "hide",
    value: function hide() {
      d3Select(this.chart).selectAll('.barfocus, .focus-grid').attr('opacity', '0');
      d3Select(this.ref).style('visibility', 'hidden');
    }
  }, {
    key: "getTooltipRowLabel",
    value: function getTooltipRowLabel(d, row) {
      if (d[row.key].labelDate) {
        return this.labelFormat(moment(d[row.key].labelDate).toDate());
      }

      return row.label || row.key;
    }
  }, {
    key: "show",
    value: function show(d, triggerElement, parentNode) {
      var _this = this;

      var elementWidthRatio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      if (!this.visibleKeys.length) {
        return;
      }

      d3Select(parentNode).select('.focus-grid, .barfocus').attr('opacity', '1');
      var position = this.calculatePosition(triggerElement, elementWidthRatio);
      var keys = this.visibleKeys.map(function (row) {
        return "\n\t\t\t\t\t<li class=\"key-row\">\n\t\t\t\t\t\t<div class=\"key-container\">\n\t\t\t\t\t\t\t<span\n\t\t\t\t\t\t\t\tclass=\"key-color\"\n\t\t\t\t\t\t\t\tstyle=\"background-color: ".concat(_this.getColor(row.key), "\">\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span class=\"key-key\">").concat(_this.getTooltipRowLabel(d, row), "</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<span class=\"key-value\">").concat(_this.valueFormat(d[row.key].value), "</span>\n\t\t\t\t\t</li>\n\t\t\t\t");
      });
      var tooltipTitle = this.title ? this.title : this.labelFormat(moment(d.date).toDate());
      d3Select(this.ref).style('left', position.x + 'px').style('top', position.y + 'px').style('visibility', 'visible').html("\n\t\t\t\t<div>\n\t\t\t\t\t<h4>".concat(tooltipTitle, "</h4>\n\t\t\t\t\t<ul>\n\t\t\t\t\t").concat(keys.join(''), "\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t"));
    }
  }]);

  return ChartTooltip;
}();

export default ChartTooltip;
//# sourceMappingURL=tooltip.js.map